module.exports = __webpack_public_path__ + "static/img/quxiaoquantijingyin2.6a3c7b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/quxiaoquantijingyin2.png
// module id = FkwF
// module chunks = 24